import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { usePageTrack } from '../analytics/use-page-track';
import { useUpdatePageTitle } from './use-update-page-title';

/** KU
 *
 * This app-wide hook tracks a page event (via {@link handlePageTrack}) and
 * updates the document.title whenever the current in-app location changes */
export default function useOnLocationChanged() {
  const location = useLocation();

  const { pathname, search } = location;
  const { handlePageTrack } = usePageTrack();
  const { handleUpdatePageTitle } = useUpdatePageTitle();

  useEffect(handlePageTrack, [pathname, search]);
  useEffect(() => handleUpdatePageTitle(), [pathname]);
}
